import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "@js2/modules/network/consts";
import { advancedSearchKeys } from "../modules/samples/queryKeys";
import api from "../services/api";
import { UserConfig } from "./@types/userconfig";

export const useUserConfig = () =>
  useQuery({
    queryKey: advancedSearchKeys.fetchUserData,
    queryFn: () => api.getUserData(),
    select: (response: AxiosResponse<UserConfig>) => {
      const { search_columns = {}, ...rest } = response?.data ?? {};
      return {
        ...search_columns,
        ...rest
      };
    },
    ...USEQUERY_DISABLE_REFETCH_OPTIONS
  });
